$('#close-blog-filter, #blog-filter-submit-results').on('click', function () {
  closeFilterModal();
})

$('#reset-blog-filter').on('click', function () {
  $('.article-filters .filter-check:checked').each( function () {
    $(this).prop('checked', false)
  })
  $('#blog-filter-submit-results').addClass('active')
  getFilterCreateArticles()
})

$('#cat-filters-wrapper').on('click', function(e) {
  if (e.target !== this) {
    return;
  }
  closeFilterModal();
});

const closeFilterModal = () => {
  $('body').removeClass('filter-open')
  $('#blog-filter-submit-results').removeClass('active')
}

$('#blog-filter-toggle').on('click', function () {
  $('body').addClass('filter-open')
})

$('.article-filters .filter-check').change(function() {
  $('#blog-filter-submit-results').addClass('active')
  $('.js-blog-search-input').val('')
  var tag = $(this).attr('id');
  getFilterCreateArticles();
});

const removeFilterTag = (tag) => {
  const tagSlug = $(tag).data('remove-tag')
  $(`.tag-${tagSlug}`).prop('checked', false)
  getFilterCreateArticles()
}

var $searchInput = $('.js-blog-search-input');
var $searchForms = $('.js-blog-search-form');
var typingTimer; //timer identifier
var doneTypingInterval = 750;
var validBlogSortModes = ['default', 'newest', 'oldest', 'title-asc', 'title-desc'];

const syncBlogSearchInputs = (value) => {
  $searchInput.val(value);
}

const getActiveBlogSort = () => {
  const sortMode = new URLSearchParams(window.location.search).get('sort');

  if (validBlogSortModes.indexOf(sortMode) === -1) {
    return 'default';
  }

  return sortMode;
}

const updateUrlWithSort = (url, sortMode) => {
  if (!url) {
    return url;
  }

  var nextUrl = removeURLParameter(url, 'sort');

  if (!sortMode || sortMode === 'default') {
    return nextUrl;
  }

  nextUrl += nextUrl.indexOf('?') === -1 ? '?' : '&';

  return `${nextUrl}sort=${encodeURIComponent(sortMode)}`;
}

const normalizeArticleDateValue = (dateMarkup) => {
  const temp = document.createElement('div');
  temp.innerHTML = dateMarkup || '';

  const timeEl = temp.querySelector('time');
  const dateValue = timeEl
    ? (timeEl.getAttribute('datetime') || timeEl.textContent || '')
    : (temp.textContent || temp.innerText || '');
  const parsedDate = Date.parse(dateValue);

  if (Number.isNaN(parsedDate)) {
    return 0;
  }

  return parsedDate;
}

const escapeAttributeValue = (value) => {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

const syncBlogPaginationSort = () => {
  const sortMode = getActiveBlogSort();

  $('#blog-pagination a, #AjaxinatePagination a').each(function () {
    const href = $(this).attr('href');

    if (!href) {
      return;
    }

    $(this).attr('href', updateUrlWithSort(href, sortMode));
  });
}

const applyBlogSort = () => {
  const sortMode = getActiveBlogSort();
  const grid = document.querySelector('.catalog-product-grid');

  if (!grid) {
    return;
  }

  const cards = Array.from(grid.querySelectorAll('.catalog-product'));

  if (!cards.length) {
    syncBlogPaginationSort();
    return;
  }

  cards.sort((leftCard, rightCard) => {
    const leftTitle = leftCard.getAttribute('data-sort-title') || '';
    const rightTitle = rightCard.getAttribute('data-sort-title') || '';
    const leftPublishedAt = parseInt(leftCard.getAttribute('data-published-at') || '0', 10);
    const rightPublishedAt = parseInt(rightCard.getAttribute('data-published-at') || '0', 10);
    const leftDefaultOrder = parseInt(leftCard.getAttribute('data-default-order') || '0', 10);
    const rightDefaultOrder = parseInt(rightCard.getAttribute('data-default-order') || '0', 10);

    if (sortMode === 'newest' && leftPublishedAt !== rightPublishedAt) {
      return rightPublishedAt - leftPublishedAt;
    }

    if (sortMode === 'oldest' && leftPublishedAt !== rightPublishedAt) {
      return leftPublishedAt - rightPublishedAt;
    }

    if (sortMode === 'title-asc') {
      return leftTitle.localeCompare(rightTitle) || (leftDefaultOrder - rightDefaultOrder);
    }

    if (sortMode === 'title-desc') {
      return rightTitle.localeCompare(leftTitle) || (leftDefaultOrder - rightDefaultOrder);
    }

    return leftDefaultOrder - rightDefaultOrder;
  });

  cards.forEach((card) => {
    grid.appendChild(card);
  });

  syncBlogPaginationSort();
}

const getBlogSearchResults = (searchTerm, page) => {
  if ( !searchTerm ) {
    getFilterCreateArticles()
    return
  }
  let searchURL = `/search?type=article&q=${encodeURIComponent(searchTerm)}&view=blog-filter`
  if ( page ) {
    searchURL += `&page=${page}`
  }
  $('.catalog-product-grid').html('<div class="h1 blog-loading loading text-center font-bemio uppercase py-5">Loading</div>')
  $.ajax({
    type: 'GET',
    url: searchURL,
    dataType: 'json',
    success: function(res){
      $('.catalog-product-grid').html('')
      $('.filter-check').each( function () {
        $(this).prop('checked', false)
      })
      
      $('.selected-tags').html('')
      let baseUrl = window.location.href.split('/tagged')[0]
      baseUrl = baseUrl.split('?')[0]
      baseUrl = baseUrl.slice(-1) === '/' ? baseUrl.slice(0, -1) : baseUrl

      let searchUrl = `${baseUrl}/?q=${encodeURIComponent(searchTerm)}`
      if ( res.page !== '1' ) {
        searchUrl += `&page=${res.page}`
      }
      searchUrl = updateUrlWithSort(searchUrl, getActiveBlogSort())

      // Replace url with search params
      window.history.replaceState(null, $('.blog-title a').text() + 'tagged with ' + searchTerm, searchUrl);

      // Add search pagination
      const pagination = decodeURIComponent(res.pagination);
      $('#blog-pagination').html(pagination)

      // Switch search pagination urls 
      $('.paginate-link').each( function () {
        let newSearchUrl = $(this).attr('href').replace('/search', baseUrl)
        newSearchUrl = removeURLParameter(newSearchUrl, 'view')
        newSearchUrl = removeURLParameter(newSearchUrl, 'type')
        newSearchUrl = updateUrlWithSort(newSearchUrl, getActiveBlogSort())
        $(this).attr('href', newSearchUrl)
      })
      
      // Clear catalog grid before appending new items
      
      $.each(res.articles, function(index, item) {
        // console.log("filter found: " + res['articles'][index]['title']);
        var date = item.date;
        var url = item.url;
        var bg = item.image;
        var title = item.title;
        if (item.excerpt != "") {
          var excerpt = item.excerpt;
        } else {
          var excerpt = item.content;
        }
        createArticle(date, url, bg, title, excerpt);
      });
      applyBlogSort();
    },
    error: function(req, status){
      console.log(req, status);
    }
  })
}

const submitSearch = (sourceInput) => {
  const searchTerm = sourceInput ? $(sourceInput).val() : $searchInput.first().val()
  syncBlogSearchInputs(searchTerm)
  getBlogSearchResults(searchTerm)
}

$searchInput.on('keyup', function () {
  clearTimeout(typingTimer);
  const currentInput = this;
  typingTimer = setTimeout(function () {
    submitSearch(currentInput);
  }, doneTypingInterval);
})

$searchInput.on('keydown', function () {
  clearTimeout(typingTimer);
});

if ( $searchForms.length ) {
  $searchForms.on('submit', function (e) {
    e.preventDefault()
    submitSearch($(this).find('.js-blog-search-input').first())
  })
  
  const urlParams = new URLSearchParams(window.location.search);
  const searchQuery = urlParams.get('q');
  const page = urlParams.get('page');
  
  if ( searchQuery ) {
    syncBlogSearchInputs(searchQuery)
    getBlogSearchResults(searchQuery, page)
  }
}

applyBlogSort();

//Ajax get articles
const getFilterCreateArticles = () => {
  var checkList = [];
  // Clear all remove tags and add them back based on checked options
  $('.selected-tags').html('')
  $('#cat-filters input[type=checkbox]:checked').each(function() {
    const tag = $(this).attr('id')
    checkList.push(tag);
    const removeTag = $('.blog-filter-tag-dummy').clone()
    $(removeTag[0]).data('remove-tag', tag).css('display', 'flex').removeClass('blog-filter-tag-dummy')
    $('span', removeTag[0]).text($(this).data('name'))
    $('.selected-tags').append(removeTag)
  });
  
  var len = checkList.length;
  if ( len ) {
    $('#reset-blog-filter').removeClass('hidden')
  } else {
    $('#reset-blog-filter').addClass('hidden')
  }
  // console.log(tag + ' filter activated');
  const filterList = checkList.join('+')
  var currUrl =  removeURLParameter(window.location.href, 'page').split('/tagged/')[0];
  currUrl = currUrl.split('?')[0]
  currUrl = currUrl.slice(-1) === '/' ? currUrl.slice(0, -1) : currUrl
  currUrl += len 
    ? '/tagged/' + filterList
    : ''
  const historyUrl = updateUrlWithSort(currUrl, getActiveBlogSort());
  window.history.replaceState(null, $('.blog-title a').text() + 'tagged with ' + filterList, historyUrl);
  $('.catalog-product-grid').attr('data-filters', filterList);
  $('.catalog-product-grid .unfiltered').addClass('hidden');
  $('.catalog-product-grid .filtered').remove();
  
  // } else if (len == 0) {
    // console.log('filters cleared');
    // $('.catalog-product-grid').attr('data-filters', "none");
    // $('.catalog-product-grid .filtered').remove();
    // $('.catalog-product-grid .unfiltered, label, .catalog-filters-wrap ul li.hidden').removeClass('hidden');
    // hideShowBlogFilterOptions();
  // }
  var currUrl =  removeURLParameter(window.location.href, 'page');
  ajaxTarget = currUrl + (currUrl.indexOf('?') === -1 ? '?view=ajax' : '&view=ajax');
  $('.catalog-product-grid').html('<div class="h3 blog-loading loading text-center font-bemio uppercase py-5">Loading</div>')
  $.ajax({
    type: 'GET',
    url: ajaxTarget,
    dataType: 'json',
    success: function(res){
      $('.catalog-product-grid').html('')
      // Decode pagination and append to pagination div
      const pagination = decodeURIComponent(res.pagination);
      $('#blog-pagination').html(pagination)
      $.each(res['articles'], function(index, item) {
        // console.log("filter found: " + res['articles'][index]['title']);
        var date = res['articles'][index]['date'];
        var url = res['articles'][index]['url'];
        var bg = res['articles'][index]['image'];
        var title = res['articles'][index]['title'];
        if (res['articles'][index]['excerpt'] != "") {
          var excerpt = res['articles'][index]['excerpt'];
        } else {
          var excerpt = res['articles'][index]['content'];
        }
        createArticle(date, url, bg, title, excerpt);
      });
      applyBlogSort();
      $('label').each(function() {
        var tag = $(this).attr('data-url');
        if($.inArray(tag, res['tags']) == -1) {
          $(this).addClass("hidden");
          $(this).parent().addClass("hidden");
        } else {
          $(this).removeClass("hidden");
          $(this).parent().removeClass("hidden");
        };
      });
      // hideShowBlogFilterOptions();
    },
    error: function(req, status){
          console.log(req, status);
    }
  })
}

const normalizeArticleExcerpt = (excerpt, maxWords) => {
  const temp = document.createElement('div');
  temp.innerHTML = excerpt || '';

  const text = (temp.textContent || temp.innerText || '')
    .replace(/\s+/g, ' ')
    .trim();

  if (!maxWords || !text) {
    return text;
  }

  const words = text.split(' ');
  if (words.length <= maxWords) {
    return text;
  }

  return `${words.slice(0, maxWords).join(' ')}...`;
}
  
const createArticle = (date, url, bg, title, excerpt, tag) => {
    const gridExcerpt = normalizeArticleExcerpt(excerpt, 25);
    const listExcerpt = normalizeArticleExcerpt(excerpt, 34);
    const sortTitle = escapeAttributeValue((title || '').toLowerCase());
    const publishedAtValue = normalizeArticleDateValue(date);
    const defaultOrder = document.querySelectorAll('.catalog-product-grid .catalog-product').length;
    var divCont  = `<div class="catalog-product filtered ${tag || ''}" data-sort-title="${sortTitle}" data-published-at="${publishedAtValue}" data-default-order="${defaultOrder}">`;
    var divOv = `<div class="catalog-product-overlay" style="background: linear-gradient( rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35) ), url(${bg}) no-repeat center center / cover">`;
    var divInfo = `<div class="article-info">
                    <p class="catalog-title">
                      <a class="title" href="${url}">${title}</a>
                    </p><p class="article-date">${date}</p>
                  </div>`;
    var divExcerpt = `<div class="article-excerpt">
                        <p class="article-summary">${gridExcerpt}</p>
                        <a class="button read-more" href="${url}">Continue Reading</a>
                      </div>`;
    var divListMeta = `<div class="article-details">
                        <div class="article-excerpt">
                          <p class="article-summary">${listExcerpt}</p>
                        </div>
                        <div class="article-cta">
                          <a class="read-more" href="${url}">Continue Reading</a>
                        </div>
                      </div>`;
    var divOvClose = '</div>';
    var divMobileOpen = '<div class="mobile-article mobile">';
    var divMobileClose = '</div>';
    var divClose1 = '</div>';
    var divClose2 = '</div>';
  
    var div = divCont +
              divOv +
              divInfo +
              divExcerpt +
              divOvClose +
              divMobileOpen +
              divInfo +
              divListMeta +
              divMobileClose +
              divClose1 +
              divClose2;
    $('.catalog-product-grid').append(div);
}

//Hide Empty Filter Blocks
const hideShowBlogFilterOptions = () => {
  $('.catalog-filters .filter-block').each(function () {
    if ($(this).children('ul').children('li:not(.hidden)').length < 1) {
      $(this).hide();
    } else if ($(this).css('display') == 'none' ) {
      $(this).show();
    }
  });
  $('.filter-block').each( function () {
    // If all li elements of the current category are hidden, hide the whole category
    if ( $('li.hidden', this).length === $('li', this).length ) {
      $(this).hide()
    } else {
      $(this).show()
    }
  })
}
